import React from 'react';
import styles from './table.module.scss';

export default class TablePagesControl extends React.Component {
    constructor(props) {
        super(props);
        this.handlePageButtonClick = this.handlePageButtonClick.bind(this);
    }

    handlePageButtonClick(e, pageNumber) {
        e.preventDefault();
        var filter = this.props.itemsFilter;
        filter.pagesFilter.currentPage = pageNumber;
        this.props.getItemsFunction(filter);
    }

    renderPages() {
        let pageCount = this.props.itemsFilter.pagesFilter.pageCount;
        let currentPage = this.props.itemsFilter.pagesFilter.currentPage;
        let isPrevPageEnabled = currentPage > 1;
        let isNextPageEnabled = currentPage < pageCount;
        const shownCount = 10;
        let lastShownPage = pageCount <= shownCount ? pageCount : (currentPage < 5 ? shownCount : Math.min(currentPage + 5, pageCount));
        let firstShownPage = Math.max(lastShownPage - (shownCount -1), 1);
        const items = [];
        items.push({ linkText: '<', page: currentPage - 1, isEnabled: isPrevPageEnabled });
        
        for (let i = firstShownPage; i <= lastShownPage; i++) {
            items.push({ linkText: i, page: i, isCurrent: i === currentPage, isEnabled: i !== currentPage });
        }

        items.push({ linkText: '>', page: currentPage + 1, isEnabled: isNextPageEnabled });

        return (
            <div className={styles.table_pages_panel}>
            {
                items.map((item, index) =>
                <button key={index} className={styles.table_page_button} disabled={!item.isEnabled} onClick={(e) => this.handlePageButtonClick(e, item.page)}> {item.linkText} </button>
                )
            }
            </div>    
            );
        }
    
    render() {
        return (
            <div>
                {
                    this.renderPages()
                }

            </div>
        );
    }
}